/* eslint-disable import/prefer-default-export */
import { useLayoutEffect } from 'react';

const MOUNT_SETTLE_DELAY_MS = 500;

export function useAutoScrollOnHeightIncrease (ref) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    let prevHeight = el.scrollHeight;
    let settled = false;

    const settleTimeout = setTimeout(() => {
      prevHeight = el.scrollHeight;
      settled = true;
    }, MOUNT_SETTLE_DELAY_MS);

    const observer = new MutationObserver(() => {
      if (!settled) return;

      const newHeight = el.scrollHeight;

      if (newHeight > prevHeight) {
        el.scrollTo({
          top: el.scrollHeight,
          behavior: 'smooth'
        });
        prevHeight = newHeight;
      }
    });

    observer.observe(el, {
      childList: true,
      subtree: true
    });

    return () => {
      clearTimeout(settleTimeout);
      observer.disconnect();
    };
  }, [ref]);
}
